<template>
  <div>
    <FITWorkflowProgressbar class="mb-0 pb-0" ref="lifeWorkflowProgress" :startingIndex="workflowCurrentIndex" :steps="workflow">
    </FITWorkflowProgressbar>
    <FITModal ref="newLifeModal" :noFooter="true" reference="newLifeModal" :title="$t('general.notification')">
      <div slot="body">
        <div class="my-4">
          <h5 v-html="notificationContent"></h5>
        </div>
        <div class="text-right">
          <b-btn variant="primary" @click="closeNewLifeModal">{{$t('general.ok')}}</b-btn>
        </div>
      </div>
    </FITModal>
    <FITModal ref="deletePolicyModal" reference="deletePolicy" :title="$t('osm.contents.general.delete')" @click="onClickModalDelete">
      <div slot="body">
        <div class="my-4">
          <h5 v-html="$t('osm.contents.general.deletePolicyConfirm',{policyNumber: lifeGeneralInfo.policyNumber, policyRef: lifeGeneralInfo.policyReference})"></h5>
        </div>
      </div>
    </FITModal>
    <b-modal id="cbModal" size="lg" ref="cbModal" @ok="onClickCbModalOk" :ok-variant="isFirstTimeClickedModalOk?'primary':'success'" cancel-variant="danger" @hidden="onHideCbModal" :title="$t('osm.contents.general.changeBusiness.title') + ' - ' + $t(`osm.contents.general.changeBusiness.${this.selectedChangeBusinessAction}`)">
      <div>
        <p v-html="changeBusinessConfirmContent"></p>
      </div>
      <div class="mt-3">
        <div class="w-50">
          <FITDatePicker v-if="selectedChangeBusinessAction != 'changePremiumType'" :label="$t(`osm.contents.general.changeBusiness.${selectedChangeBusinessAction}`) +' '+$t('general.date')" :width="8" v-model="changeBusinessEffectDate" :placeholder="$t('general.selectDate')"></FITDatePicker>
        </div>
        <FITSelect v-if="selectedChangeBusinessAction == 'changePremiumType'" :label="$t('osm.contents.lifePolicy.generalInformation.premiumType')" :width="8" :options="getTranslatedOptions(`${$i18n.locale}`,premiumTypeList)" v-model="newPremiumType"></FITSelect>
        <FITWorkflowFileUpload ref="fitFileUpload"></FITWorkflowFileUpload>
      </div>
      <div v-if="!isFirstTimeClickedModalOk" class="my-4">
        <h5 v-html="changeBusinessWarning" style="color:red"></h5>
      </div>
      <b-alert :show="modalAlertCd" dismissible variant="danger" @dismissed="modalAlertCd=0">{{$t('general.updateError')}}</b-alert>
    </b-modal>
    <b-row align-h="center" class="mt-0 pt-0">
      <div class="w-75">
        <b-alert :show="dismissCountDown" dismissible :variant="submitSuccess?'success':'danger'" @dismissed="dismissCountDown=0">{{$t('general.updateSuccess')}}</b-alert>
        <b-row align-h="between" class="mb-3">
          <b-col align-self="start">
            <FITButton v-if="!prevBtnStatus.hide " @click="submitForm(true)" variant="primary" :text="$t('general.workflow.previous')" size="md"></FITButton>
            <FITButton class="ml-3" v-if="!deleteBtnStatus.hide" @click="onClickDeletePolicy" variant="warning" :text="$t('osm.contents.general.delete')" size="md"></FITButton>
          </b-col>
          <b-col align-self="end" class="text-right">
            <!-- <FITButton class="mr-3" v-if="!saveBtnStatus.hide" @click="onClickSave" :text="$t('general.CURD.update')" size="md"></FITButton>
 -->
            <!-- <FITDropdown class="mr-3" v-if="workflowCurrentIndex > 5" v-model="changeBusinessActions.value.action" variant="primary" :text="changeBusinessActions.label" :options="changeBusinessActions.options" @clicked="onClickChangeBusiness"></FITDropdown> -->
            <FITButton v-if="!nextBtnStatus.hide && !isPolicyCompleted" @click="submitForm(false)" variant="primary" :text="nextBtnText" size="md"></FITButton>
            <template v-else>
              <FITButton v-if="!rejectBtnStatus.hide && !isPolicyRejected" class="mr-3" @click="submitForm(false, 0)" size="md" variant="danger" :text="$t('osm.contents.lifePolicy.workflowReject')"></FITButton>
              <FITButton v-if="!inforceBtnStatus.hide " @click="submitForm(false, 1)" size="md" variant="success" :text="$t('osm.contents.lifePolicy.workflowInforce')"></FITButton>
            </template>
            <!-- <div v-if="isPolicyCompleted" class="text-right">
              <h3><b-badge variant="success">{{$t('osm.contents.general.completedPolicy')}}</b-badge>
              </h3>
            </div> -->
            <div v-if="isPolicyRejected" class="text-right">
              <h3><b-badge variant="danger">{{$t('osm.contents.general.rejectedPolicy')}}</b-badge>
              </h3>
            </div>
          </b-col>
        </b-row>
        <!-- hard coded props for OutRequirement -->
        <FITOutstandingRequirement v-if="!orSectionStatus.hide" policyType="P" :policyID="this.policyID"></FITOutstandingRequirement>
        <NewLifePolicyGeneralInfo ref="lifeGeneralInfoComponent" @input="onChangeGeneralInfo">
        </NewLifePolicyGeneralInfo>
        <NewLifePolicyRiders ref="lifeRiderComponent" v-if="!riderSectionStatus.hide">
        </NewLifePolicyRiders>
        <b-row>
          <b-col align-self="start">
            <FITButton v-if="!prevBtnStatus.hide" @click="submitForm(true)" variant="primary" :text="$t('general.workflow.previous')" size="md"></FITButton>
          </b-col>
          <b-col align-self="end" class="text-right">
            <!-- <FITButton v-if="!saveBtnStatus.hide" class="mr-3" @click="onClickSave" :text="$t('general.CURD.update')" size="md"></FITButton> -->
            <FITButton v-if="!nextBtnStatus.hide && !isPolicyCompleted" @click="submitForm(false)" variant="primary" :text="nextBtnText" size="md"></FITButton>
            <template v-else>
              <FITButton v-if="!rejectBtnStatus.hide && !isPolicyRejected" class="mr-3" @click="submitForm(false, 0)" size="md" variant="danger" :text="$t('osm.contents.lifePolicy.workflowReject')"></FITButton>
              <FITButton v-if="!inforceBtnStatus.hide" @click="submitForm(false, 1)" size="md" variant="success" :text="$t('osm.contents.lifePolicy.workflowInforce')"></FITButton>
            </template>
          </b-col>
        </b-row>
      </div>
    </b-row>
  </div>
</template>
<script type="text/javascript">
import { NewLifePolicyGeneralInfo, NewLifePolicyRiders } from '../components'
import { FITWorkflowProgressbar, FITButton, FITModal, FITOutstandingRequirement, FITDropdown, FITDatePicker, FITWorkflowFileUpload, FITSelect,FITValidationBus } from '@/components'
import Vue from 'vue';
import { mapGetters, mapState } from 'vuex'
import workflowStepRequirement from '../assets/_workflowStepRequirement'
import { FormWizard, TabContent, WizardButton, WizardStep } from 'vue-form-wizard'

export default {
  name: "NewLifePolicyContainer",
  components: {
    FITDropdown,
    FITSelect,
    FITButton,
    FITWorkflowProgressbar,
    NewLifePolicyGeneralInfo,
    NewLifePolicyRiders,
    FITModal,
    FITOutstandingRequirement,
    FITDatePicker,
    FITWorkflowFileUpload
  },
  computed: {
     permissionLevel(){
      return this.$store.state.permissionLevel;
    },
    premiumTypeList() {
      return this.getOptions("premiumType");
    },
    nextBtnText() {
      if (this.workflowCurrentIndex == 8) {
        return this.$t('general.workflow.finish');
      }
      return this.$t('general.workflow.next');
    },
    changeBusinessConfirmContent() {
      return this.$t('osm.contents.general.changeBusiness.confirmActionContent', {
        policyOwner: this.policyOwner.english + ' ' + this.policyOwner.chinese,
        policyNumber: this.lifeGeneralInfo.policyNumber
      })
    },
    currentStepRequirements() {
      return workflowStepRequirement.requirements['step' + (this.workflowCurrentIndex + 1)]
    },
    ...mapGetters("LifePolicy", [
      'getTranslatedOptions'
    ]),
    ...mapState({
      'vuexFinalResult': state => state.Validation.validationFinalResult,
      riderSectionStatus: state => state.LifePolicy.newLife.fields.riderSection,
      policyOwner: state => state.LifePolicy.newLife.policyOwner,
      insurer: state => state.LifePolicy.newLife.insurer,
      currentAgent: state => state.LifePolicy.newLife.currentAgent,
      originalAgent: state => state.LifePolicy.newLife.originalAgent,
      productName: state => state.LifePolicy.newLife.productName,
      workflowCurrentIndex: state => state.LifePolicy.newLife.workflowCurrentStep,
      policyID: state => state.LifePolicy.newLife.policyID,
      prevBtnStatus: state => state.LifePolicy.newLife.fields.prevBtn,
      nextBtnStatus: state => state.LifePolicy.newLife.fields.nextBtn,
      inforceBtnStatus: state => state.LifePolicy.newLife.fields.inforceBtn,
      deleteBtnStatus: state => state.LifePolicy.newLife.fields.deleteBtn,
      isPolicyRejected: state => state.LifePolicy.newLife.isRejected,
      isPolicyCompleted: state => state.LifePolicy.newLife.isCompleted,
      orSectionStatus: state => state.LifePolicy.newLife.fields.orSection,
      rejectBtnStatus: state => state.LifePolicy.newLife.fields.rejectBtn,
      saveBtnStatus: state => state.LifePolicy.newLife.fields.saveBtn,
      lifeGeneralInfo: state => state.LifePolicy.newLife.lifeGeneralInfo,
      paymentMethodID: state => state.LifePolicy.newLife.paymentMethodID,
      allSelections: state => state.LifePolicy.lifeSelectionList
    }),
    changeBusinessWarning() {
      return this.$t('osm.contents.general.changeBusiness.confirmActionWarning', {
        action: this.$t(`osm.contents.general.changeBusiness.${this.selectedChangeBusinessAction}`),
      })
    },
  },
  watch: {
    workflowCurrentIndex(newData,oldData) {
      this.transitToCurrentStep();
      this.getValidationRule(newData);
    },
    vuexFinalResult(newData,oldData){
       let result = newData;
       // console.log("Final Result: "+newData);
      if(result){
        this.submitAction( this.submit.isToPrev, this.submit.policyActionType );
        this.$store.commit('Validation/validationReset');
        // FITValidationBus.$emit('reset', true);
      }
    }
  },
  data() {
    return {
      newPremiumType: '',
      modalAlertCd: 0,
      dismissSecs: 3,
      dismissCountDown: 0,
      submitSuccess: false,
      newFileUploaded: {},
      changeBusinessEffectDate: '',
      isFirstTimeClickedModalOk: true,
      selectedChangeBusinessAction: '',
      notificationContent: this.$t('osm.contents.general.completedPolicy'),
      workflowPrevIndex: 0,
      form: {
        attachment: {},
        files: {}
      },
      workflow: [
        { name: this.$t('osm.contents.lifePolicy.workflowCreate') },
        { name: this.$t('osm.contents.lifePolicy.workflowConfirm') },
        { name: this.$t('osm.contents.lifePolicy.workflowSentOut') },
        { name: this.$t('osm.contents.lifePolicy.workflowUnderwriting') },
        { name: this.$t('osm.contents.lifePolicy.workflowReject') },
        { name: this.$t('osm.contents.lifePolicy.workflowInforce') },
        { name: this.$t('osm.contents.lifePolicy.workflowCompanyReceive') },
        { name: this.$t('osm.contents.lifePolicy.workflowAgentReceive') },
        { name: this.$t('osm.contents.lifePolicy.workflowCustomerReceive') }
      ],
      changeBusinessActions: {
        value: { rowID: '', action: '' },
        key: 'actions',
        label: this.$t('osm.contents.general.changeBusiness.title'),
        options: [
          { text: this.$t('osm.contents.general.changeBusiness.lapse'), key: 'lapse' },
          { text: this.$t('osm.contents.general.changeBusiness.surrender'), key: 'surrender' },
          { text: this.$t('osm.contents.general.changeBusiness.reinstate'), key: 'reinstate' },
          { text: this.$t('osm.contents.general.changeBusiness.transferOut'), key: 'transferOut' },
          { text: this.$t('osm.contents.general.changeBusiness.changePremiumType'), key: 'changePremiumType' }
        ]
      },
      submit:{
        isToPrev:false,
        policyActionType:1,
      }

    }
  },
  created() {
    // console.debug(this.workflowCurrentIndex);
    if (this.workflowCurrentIndex > 0) {
      this.$store.dispatch('LifePolicy/getLifeDetail').then((json) => {
        Vue.set(this, 'workflowPrevIndex', this.workflowCurrentIndex);
      }).catch((error) => {
        console.log(error);
      })
    }
      this.getValidationRule(this.workflowCurrentIndex);
      this.permissionCheck();
  },
  methods: {
    permissionCheck(){
      let permissionLevel = this.permissionLevel;
      console.log(permissionLevel);
      if(permissionLevel>3.5){
        this.$store.commit('LifePolicy/disabledButtonStatus');
      }
    },
    getValidationRule(index){

      FITValidationBus.$emit('reset',true);
      this.$store.commit('Validation/validationReset');
      this.$store.commit('Validation/setAlertMsg',{alertMsg: this.$t("validation.alertMsg.error")});
      let action;
        switch(index){
          case 0:
          action = 'new';
          break;
          case 1:
          action = 'confirm';
          break;
          case 2:
          action = 'sendOut';
          break;
          case 5:
          action = 'inforce';
          break;
          case 6:
          action = 'companyReceive';
          break;
          case 7:
          action = 'agentReceive';
          break;
          case 8:
          action = 'customerReceive';
          break;
          default:
          action = 'new';
          break;
        }

      this.$store.dispatch('Validation/getValidationRule',`/lifePolicy/${action}`);

    },
   submitForm(isToPrev, policyActionType){
      if(isToPrev){
      this.submitAction(isToPrev, policyActionType);
      }else{
      this.$store.dispatch('Validation/validationCheckBeforeSubmit');
      this.submit.isToPrev = isToPrev;
      this.submit.policyActionType = policyActionType;
      }
    },
    onClickModalDelete(event) {
      if (!event) {
        return;
      }
      this.$store.dispatch('LifePolicy/deleteLifePolicy', this.policyID).then((json) => {
        this.$refs.deletePolicyModal.closeModal();
        this.$store.dispatch('LifePolicy/setWorkflowCurrentStep', 0);
        this.$router.replace({ name: 'Life Policy List', params: { alertContent: this.$t('osm.contents.general.deleteSuccess'), alertVariant: 'success' } });
      })
    },
    onClickDeletePolicy() {
      this.$refs.deletePolicyModal.openModal();
    },
    nextwf() {
      this.$store.dispatch('LifePolicy/setWorkflowCurrentStep', this.workflowCurrentIndex + 1);
    },

    onClickSave() {
      this.$store.dispatch('LifePolicy/saveLifePolicy', this.form).then(() => {})
    },

    submitAction(isToPrev, policyActionType) {
      var apiIndex = this.workflowCurrentIndex;
      if (isToPrev && apiIndex != 4 && apiIndex != 5) {
        this.$store.commit({ type: 'LifePolicy/setIsRejected', value: false })
        this.$store.commit({ type: 'LifePolicy/setIsCompleted', value: false })
        apiIndex -= 1;
      }
      var uploadedfileData = this.$refs.lifeGeneralInfoComponent.uploadFile();
      this.$refs.lifeGeneralInfoComponent.saveToVuex();
      if (!this.riderSectionStatus.hide) {
        this.$refs.lifeRiderComponent.saveToVuex();
      }

      // console.debug(this.form);
      this.setFormFromVuex();
      this.onUploadedFile(uploadedfileData);

      switch (apiIndex) {
        case 0:
          this.$store.dispatch('LifePolicy/createLifePolicy', this.form).then(() => {
            // Vue.set(this.form, 'attachment', {});
            // Vue.set(this.form, 'files', {});
            this.$refs.lifeGeneralInfoComponent.resetFileUpload();
          }).catch((err) => {
            console.log(this.form)
            console.log(err);
          });
          break;
        case 1:
          this.$store.dispatch('LifePolicy/confirmLifePolicy', { form: this.form, isToPrev: isToPrev }).then(() => {
            // Vue.set(this.form, 'attachment', {});
            // Vue.set(this.form, 'files', {});
            this.$refs.lifeGeneralInfoComponent.resetFileUpload();
          })
          break;
        case 2:
          this.$store.dispatch('LifePolicy/sendOutLifePolicy', { form: this.form, isToPrev: isToPrev }).then(() => {
            // Vue.set(this.form, 'attachment', {});
            // Vue.set(this.form, 'files', {});
            this.$refs.lifeGeneralInfoComponent.resetFileUpload();
          })
          break;
        case 3:
          switch (policyActionType) {
            case 0:
              //reject
              this.$store.dispatch('LifePolicy/setWorkflowCurrentStep', 4)
              break;
            case 1:
              //inforce
              this.$store.dispatch('LifePolicy/setWorkflowCurrentStep', 5)
              break;
          }
          break;
        case 4:
          if (isToPrev) {

            this.$store.dispatch('LifePolicy/setWorkflowCurrentStep', 3);
            break;
          }
          this.$store.dispatch('LifePolicy/rejectLifePolicy', this.policyID).then(() => {
            // Vue.set(this.form, 'attachment', {});
            // Vue.set(this.form, 'files', {});
            this.$refs.lifeGeneralInfoComponent.resetFileUpload();
            this.openNewLifeModal(0);
          })
          break;
        case 5:
          if (isToPrev) {
            // console.debug(clicked);
            this.$store.dispatch('LifePolicy/setWorkflowCurrentStep', 3);
            break;
          }
          this.$store.dispatch('LifePolicy/inforceLifePolicy', this.form).then(() => {
            // Vue.set(this.form, 'attachment', {});
            // Vue.set(this.form, 'files', {});
            this.$refs.lifeGeneralInfoComponent.resetFileUpload();
          })
          break;
        case 6:
          this.$store.dispatch('LifePolicy/companyReceiveLifePolicy', { form: this.form, isToPrev: isToPrev });
          break;
        case 7:
          this.$store.dispatch('LifePolicy/agentReceiveLifePolicy', { form: this.form, isToPrev: isToPrev });
          break;
        case 8:
          this.$store.dispatch('LifePolicy/customerReceiveLifePolicy', { form: this.form, isToPrev: isToPrev }).then(() => {
            this.openNewLifeModal(1);
          });
          break;
      }
      window.scrollTo(0,0);
    },
    // setCurrentStepFieldStatus() {
    //   this.currentStepRequirements.forEach((item) => {
    //     console.debug(item);
    //     this.$store.commit({
    //       type: 'LifePolicy/setCurrentStepFieldStatus',
    //       name: item.name,
    //       disabled: item.status.disabled,
    //       hide: item.status.hide
    //     });
    //   })
    // },
    transitToCurrentStep() {
      if (this.workflowCurrentIndex > this.workflowPrevIndex) {
        var times = this.workflowCurrentIndex - this.workflowPrevIndex;
        for (var i = 0; i < times; i++) {
          this.$refs.lifeWorkflowProgress.nextTab();
        }
      } else if (this.workflowCurrentIndex < this.workflowPrevIndex) {
        var times = this.workflowPrevIndex - this.workflowCurrentIndex;
        for (var i = 0; i < times; i++) {
          this.$refs.lifeWorkflowProgress.prevTab();
        }
      }
      Vue.set(this, 'workflowPrevIndex', this.workflowCurrentIndex);
    },
    onChangeGeneralInfo(lifeGeneralInfo) {
      Vue.set(this, 'form', lifeGeneralInfo);
    },
    onUploadedFile(files) {
      console.log(files)
      Vue.set(this.form, 'attachment', files.attachment);
      Vue.set(this.form, 'files', files.files);
      // console.log(this.form);
    },
    openNewLifeModal(val) {
      switch (val) {
        case 0:
          // rejected
          Vue.set(this, 'notificationContent', this.$t('osm.contents.general.rejectedPolicyModal', { type: this.$t('osm.contents.general.life') }));
          break;
        case 1:
          //completed
          Vue.set(this, 'notificationContent', this.$t('osm.contents.general.completedPolicyModal', { type: this.$t('osm.contents.general.life') }))
          break;
      }
      this.$refs.newLifeModal.openModal();
    },
    closeNewLifeModal() {
      this.$refs.newLifeModal.closeModal();
      this.$store.dispatch('LifePolicy/setWorkflowCurrentStep', 0);
      this.$router.replace('/osm/life/list');
    },
    setFormFromVuex() {
      Vue.set(this, 'form', JSON.parse(JSON.stringify(this.lifeGeneralInfo)));

      if (this.policyID != -1 && this.policyID != null) {
        Vue.set(this.form, 'ID', this.policyID);
      }
      // console.log(this.paymentMethodID);
      if (this.paymentMethodID != -1 && this.paymentMethodID != null) {
        Vue.set(this.form, 'paymentMethodID', this.paymentMethodID);
      }

    },
    uploadFile() {
      var fileData = this.$refs.fitFileUpload.formUploadFiles();
      console.debug(fileData);
      Vue.set(this, 'newFileUploaded', fileData);
      return fileData;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    showModalAlert() {
      this.modalAlertCd = this.dismissSecs;
    },
    onHideCbModal() {
      Vue.set(this, 'isFirstTimeClickedModalOk', true);
      Vue.set(this, 'changeBusinessEffectDate', '');
      Vue.set(this, 'newFileUploaded', {});
    },
    onClickCbModalOk(evt) {
      evt.preventDefault();
      if (this.isFirstTimeClickedModalOk) {
        Vue.set(this, 'isFirstTimeClickedModalOk', false);
        Vue.set(this, 'submitSuccess', true);
        return;
      }
      var fileData = this.uploadFile();

      switch (this.selectedChangeBusinessAction) {
        case 'lapse':
          var params = { ID: this.policyID, policyLapseDate: this.changeBusinessEffectDate, files: fileData.files, attachment: fileData.attachment }
          this.$store.dispatch('LifePolicy/lapseLife', params).then(() => {
            this.$store.dispatch('LifePolicy/getLifeDetail');
            Vue.set(this, 'submitSuccess', true);
            this.$refs.cbModal.hide();
            this.showAlert();
          }).catch((err) => {
            Vue.set(this, 'isFirstTimeClickedModalOk', true);
            Vue.set(this, 'submitSuccess', false);
            this.showModalAlert()
          })

          break;
        case 'surrender':
          var params = { ID: this.policyID, policyEndDate: this.changeBusinessEffectDate, files: fileData.files, attachment: fileData.attachment }
          this.$store.dispatch('LifePolicy/surrenderLife', params).then(() => {
            this.$store.dispatch('LifePolicy/getLifeDetail');
            Vue.set(this, 'submitSuccess', true);
            this.$refs.cbModal.hide();
            this.showAlert();

          }).catch((err) => {
            Vue.set(this, 'isFirstTimeClickedModalOk', true);
            Vue.set(this, 'submitSuccess', false);
            this.showModalAlert()
          })
          break;
        case 'reinstate':
          var params = { ID: this.policyID, policyReinstateDate: this.changeBusinessEffectDate, files: fileData.files, attachment: fileData.attachment }
          this.$store.dispatch('LifePolicy/reinstateLife', params).then(() => {
            this.$store.dispatch('LifePolicy/getLifeDetail');
            Vue.set(this, 'submitSuccess', true);
            this.$refs.cbModal.hide();
            this.showAlert();
          }).catch((err) => {
            Vue.set(this, 'isFirstTimeClickedModalOk', true);
            Vue.set(this, 'submitSuccess', false);
            this.showModalAlert()
          })
          break;
        case 'transferOut':
          var params = { ID: this.policyID, policyEndDate: this.changeBusinessEffectDate, files: fileData.files, attachment: fileData.attachment };
          this.$store.dispatch('LifePolicy/transferOutLife', params).then(() => {
            this.$store.dispatch('LifePolicy/getLifeDetail');
            Vue.set(this, 'submitSuccess', true);
            this.$refs.cbModal.hide();
            this.showAlert();

          }).catch((err) => {
            Vue.set(this, 'isFirstTimeClickedModalOk', true);
            Vue.set(this, 'submitSuccess', false);
            this.showModalAlert()
          })
          break;
        case 'changePremiumType':
          var params = { ID: this.policyID, premiumType: this.newPremiumType, files: fileData.files, attachment: fileData.attachment };
          this.$store.dispatch('LifePolicy/changePremiumTypeLife', params).then(() => {
            this.$store.dispatch('LifePolicy/getLifeDetail');
            Vue.set(this, 'submitSuccess', true);
            this.$refs.cbModal.hide();
            this.showAlert();

          }).catch((err) => {
            Vue.set(this, 'isFirstTimeClickedModalOk', true);
            Vue.set(this, 'submitSuccess', false);
            this.showModalAlert()
          })
          break;
      }

    },
    getOptions(columnName) {
      // console.debug(this.allSelections);

      var obj = this.allSelections.filter((item) => { return item.name === columnName });
      if (obj[0] == null) {
        return []
      }
      if (obj[0].options.length == 0) {
        return null;
      }
      return obj[0].options;
    },
    onClickChangeBusiness(actionType) {
      Vue.set(this, 'selectedChangeBusinessAction', actionType)
      this.$refs.cbModal.show()
    },
  },
  destroyed() {
    this.$store.dispatch('LifePolicy/resetNewLifeState');
  }
}

</script>



// WEBPACK FOOTER //
// src/Osm/LifePolicy/containers/NewLifePolicyContainer.vue